export default {
  show_inventory: "Show Inventory",
  recently_added: "Recently added",
  no_devices: "No devices added",
  os_distribution: "OS distribution",
  devices: "devices",
  Devices: "Devices",
  enrolledDevices: "Enrolled devices",
  accessories: "Accessories",
  location_service: "Location service",
  searchDevices: "Search devices",
  all: "All",
  MACOS: "Mac",
  IOS: "iPhone",
  WINDOWS: "Windows",
  ANDROID: "Android",
  TVOS: "tvOS",
  IPADOS: "iPad",
  macOS: "Mac",
  fullName: "Full name",
  date: "Date",
  windows: "Windows",
  ipad: "iPad",
  ios: "iPhone",
  android: "Android",
  POWERSHELL: "PowerShell",
  CMD: "CMD",
  BASH: "Bash",
  TRIGGERED: "Triggered",
  REPEATING: "Repeating",
  SCHEDULED: "Scheduled",
  MANUAL: "Manual",
  SYSTEM: "System",
  USER: "User",
  API_level: "API level",
  deviceManufacturer: "Device Manufacturer",
  name: "Name",
  category: "Category",
  device_name: "Device name",
  os: "OS",
  reset_password: "Reset password",
  assignedTo: "Assigned to",
  no_devices_added_yet: "No devices have been added yet",
  add_new_device: "Add New Device",
  device_overview: "Devices Overview",
  upon_assigning_devices_employees:
    "Upon assigning devices to users, they will be also assigned to the respective autopilot.",
  device_overview_tooltip:
    "Keep track of your devices, their security, and available updates.",
  compliance: "Compliance",
  security_frameworks: {
    cis1: "CIS 1",
    cis2: "CIS 2",
    soc2: "SOC 2",
    nist: "NIST",
  },
  cis_l1_coverage: "CIS level 1 <br/> coverage",
  cis_l2_coverage: "CIS level 2 <br/> coverage",
  byod: "Bring your own device (User-owned)",
  cod: "Company-owned devices",
  eod: "User-owned devices",
  ownership: "Ownership",
  version_update: "Versions & updates",
  no_item_title: "No Devices added yet",
  no_item_desc:
    "Overview of devices automatically show inclusive Security, Operating System and ets.",
  add_first_device: "Add First Device",
  addNewDevice: "Add New Device",
  addNewAccessory: "Add New Accessory",
  search: "Search",
  type: "Type",
  archiveDate: "Archive Date",
  accessorySuccessfullyAdded: "Accessory successfully added",
  success: "Success",
  inputAccessoryInformation: "Input accessory information",
  selectType: "Select type",
  serialNumber: "Serial number",
  modelOptional: "Model (Optional)",
  descriptionOptional: "Description (Optional)",
  description: "Description",
  support_info: "Support info",
  cancel: "Cancel",
  device_list: "Device list",
  add: "Add",
  noAccessoriesArchived: "No Accessories have been added yet",
  inThisPageYouCanAddAccessories:
    "In this page you can find the archived of Accessories list",
  noDevices: "No Devices",
  inThisPageYouCanAddDevices: "In this page you can find the devices list",
  overview: "Overview",
  network: "Network",
  users: "Users",
  user: "User",
  terminal: "Terminal",
  security: "Security",
  note: "Notes",
  logActivity: "Log Activity",
  operationSystem: "Operating system",
  latestVersion: "Latest version",
  updateAvailable: "Update Available",
  updating: "Updating",
  version: "Version",
  build: "Build",
  enrollmentInformation: "Enrollment information",
  method: "Method",
  agentVersion: "Agent version",
  hardwareInformation: "Hardware information",
  diskSize: "Disk size",
  diskUsed: "Disk used",
  diskAvailable: "Disk Available",
  cpuModel: "CPU model",
  memoryCapacity: "Memory capacity",
  gpuModel: "GPU model",
  gpuMemory: "GPU memory",
  agentType: "Agent type",
  rooted: "Rooted",
  model: "Model",
  supervised: "Supervised",
  sn: "S/N",
  jobPosition: "Job position",
  upTime: "Uptime",
  department: "Autopilot",
  lastSeen: "Last seen",
  ipAssignedMode: "IP assigned mode",
  change: "Change",
  macAdress: "MAC address",
  ip: "IP",
  subNet: "Subnet",
  gateway: "Gateway",
  primaryDNS: "Primary DNS",
  secondaryDNS: "Secondary DNS",
  ssid: "SSID",
  encryption: "Encryption",
  userAccounts: "Users on this device",
  accountName: "Account name",
  access: "Access",
  local: "Local",
  privilege: "Privilege",
  status: "Status",
  create_new_user: "Create new user",
  create_new_account: "Create new account",
  usernameMustNotHaveSpaces: "Username must not have space(s)",
  create_new_account_desc: "Complete this form to create a new local account.",
  create_new_user_on_device: "Create new user account on device",
  deviceRestartedSuccessfully: "Device restarted successfully.",
  deviceShutdownSuccessfully: "Device shutdown successfully.",
  deviceUnenrolledSuccessfullyOnline:
    "The unenrollment may take up to five minutes to take effect.",
  deviceWipeSuccessfullyOnline:
    "wipe may take up to five minutes to take effect.",
  deviceUnenrolledSuccessfullyOffline:
    "The device is offline. Trio will automatically unenroll the device once it is connected to the internet.",
  deviceUnenrolledFailure: "There is a problem in un-enrolling the device!",
  deviceWipeFailure: "There is a problem in wipe the device!",
  deviceRemoveFailure: "There is a problem in remove profile",
  unEnrollCommandSentSuccessfully:
    "Unenroll command sent to device Successfully. it may take several minutes to be processed completely.",
  device_shutdown_fail: "There is a problem to shutdown the device.",
  device_restart_fail: "There is a problem to restart the device.",
  device_lock_fail: "There is a problem to lock the device.",
  device_wipe_command_send: "Wipe command has been sent successfully",
  device_wipe_fail: "There is a problem to wipe the device.",
  device_wipe_success: "Device has been wiped successfully",
  shutdown_command_send_successfully:
    "Shutdown command has been sent to device successfully.",
  restart_command_send_successfully:
    "Restart command has been sent to device successfully.",
  fail: "Fail",
  power: "Power",
  reboot: "Reboot",
  shutDown: "Shut Down",
  actions: "Actions",
  deviceActions: "Device actions",
  hardwareLivePerformance: "Hardware Live Performance",
  remotelyRingDevice: "Remotely Ring Devcie",
  sendPushMessage: "Send Push/Message",
  changeDeviceName: "Change Device Name",
  change_password: "Change Password",
  unlock_account: "Unlock user account",
  change_privilege: "Change privilege",
  suspend: "Suspend",
  lostName: "Lost Mode",
  mdmBypassCode: "MDM Bypass Code",
  deviceLockedSuccessfully: "Lock command has been sent successfully.",
  deviceLockedSuccessfullyResponse: "Device has been locked successfully.",
  setPinCode: "Set PIN code",
  rememberThisPinCode: "Please remember this PIN code.",
  deviceWillUnlockWithPairCode:
    "The device can only be unlocked with the PIN code.",
  contactPhoneNumber: "Contact Phone Number",
  message: "Message",
  lockTheDevice: "Lock the device",
  lockDevice: "Lock device",
  lockDeviceDesc:
    "Protect your devices from unauthorized access by setting up a PIN code and enabling remote locking in case of theft or loss.",
  wipe_device_title: "Do you want wipe this device?",
  wipe_device_description:
    "This action will permanently erase all data on this device. Are you certain you want to proceed?",
  wipe_device_confirm_name: "To confirm, enter <b>{{name}}</b>.",
  addNewNote: "Add New Note",
  noteAddedSuccessfully: "Note Added Successfully",
  notes: "Notes",
  helpsYouSubmitNotices:
    "Write notes and reminders for yourself and other adminstrators.",
  addNote: "Add note",
  noNoteAdded: "No notes added",
  learnMore: "learn more",
  createNewNote: "Create new note",
  title: "Title",
  basicSecurityMetrics: "Security Essentials",
  basicSecurity: "Basic security",
  basicSecurityDesc: "These metrics are the basics of every device security.",
  filevault: "Filevault",
  enable: "Enable",
  disable: "Disable",
  kill: "Kill",
  kickstart: "Kickstart",
  institutionalRecovery: "Institutional recovery key",
  personalRecoveryKey: "Personal recovery key",
  personalRecoveryKeyCMS: "Personal recovery key CMS",
  downloadFile: "Download File",
  personalRecovertDeviceKey: "Personal recovery device key",
  firewall: "Firewall",
  blockIncomingConnection: "Block incoming connections",
  stealthMode: "Stealth mode",
  approvedApps: "Approved Apps",
  loggingEnable: "Logging Enable",
  loggingOptions: "Logging options",
  firewarePasswordStatus: "Firmware password status",
  passwordExist: "Password Exist",
  pendingPasswordChange: "Pending password change",
  allowOptionROMs: "Allow option ROMs",
  secureBootStatus: "Secure boot status",
  externalBootStatus: "External boot status",
  startupSecurityLevel: "Startup security level",
  isReducedSecurityActive: "Is reduced security active",
  others: "Others",
  systemIntegrityProtection: "System Integrity Protection",
  system: "System",
  remoteDesktopEnable: "Remote Desktop Enable",
  isRecoveryLockedEnable: "Is recovery locked enable",
  autoLocktime: "Auto Locktime",
  cisLevel1: "CIS level 1",
  failedControls: "issues found",
  checkAndFix: "Check & fix",
  cisLevel2: "CIS level 2",
  delete: "Delete",
  deleteValidation: "Are you sure you want to delete the note?",
  noteDeletedSuccessfully: "Note deleted successfully",
  globalProxySetting: "Global proxy setting",
  protocol: "Protocol",
  server: "Server",
  port: "Port",
  password: "Password",
  reInstallAgent: "Re-install Agent",
  wipe: "Wipe",
  wipe_device: "Wipe device",
  assignToAnotherEmployee: "Assign to Another User",
  lock: "Lock",
  softwareUpdate: "Update all Software",
  unenroll: "Unenroll",
  uninstallProfile: "Uninstall Profile",
  yes: "Yes",
  no: "No",
  rebootConfirm: `Yes, reboot`,
  rebootDialogTitle: `Do you want reboot this device?`,
  rebootDialogText: `Press ‘Yes, reboot’. Be aware, this will close all applications and unsaved data might be lost.`,
  shutDownConfirm: `Yes, shutdown`,
  shutDownDialogTitle: `Do you want to shutdown the device?`,
  shutDownDialogText: `To initiate the shutdown process, press ‘Yes, shutdown’. Please ensure that you have saved any important data or progress.`,
  enableLostModeConfirm: `Yes, enable`,
  disableLostModeConfirm: `Yes, disable`,
  enableLostModeTitle: `Do you want to enable lost mode for the device?`,
  disableLostModeTitle: `Do you want to disable lost mode for the device?`,
  enableLostModeText: `To enable lost mode process, press ‘Yes, enable. Please ensure that you have saved any important data or progress.`,
  disableLostModeText: `To disable lost mode process, press ‘Yes, disable. Please ensure that you have saved any important data or progress.`,
  updateDialogText: `Are you sure you want to Update this device?`,
  unenrollDialogText: `Are you sure you want to unenroll this device?`,
  wipeDialogText: `Are you sure you want to wipe this device?`,
  lockDevicePin: `Lock device pin`,
  resetPassword: `Reset password`,
  copyPINCode: `Copy PIN Code`,
  messageOnLockedScreen: `Message on locked screen`,
  resetToDefault: `Reset to default`,
  resetPasswordDesc: `Use the PIN code below on end-point device to unlock it.`,
  deleteDeviceDialogText: `Are you sure you want to delete this device?`,
  unenrollDialogDescription: `By choosing ‘Unenroll’, Trio will no longer manage your device. Do you wish to proceed?`,
  wipeDialogDescription: `By choosing wipe, Trio will no longer manage your device. Do you wish to proceed?`,
  deleteDialogDescription: `By choosing Delete, Trio will no longer manage your device. Do you wish to proceed?`,
  update: "Update",
  yourDeviceSecure: "Your Device Secure",
  implementRemainingControlls: "Implement remaining controls manually",
  cisLevel2Controls: "CIS level II Controls",
  fixAllControlls: "Fix all",
  problemsFound: "issues found",
  controll: "Control",
  downloadAgents: "Download agents",
  sendEnrollmentEmail: "Send enrollment email",
  enrollNewDevices: "Enroll new devices",
  agentDescription:
    "To enroll devices in a modern MDM, download and install the agent on the end devices.",
  agentlessEnrollment: "Agentless enrollment",
  agentlessDescription:
    "For enrolling devices with the agentless method, download & install the profile.",
  downloadAgentlessProfiles: "Download Agent-less Profiles",
  departmentCodes: "Autopilot's codes",
  departmentCodesDescription: `Use the unique pairing codes assigned to each autopilot to determine the appropriate policies and configurations for newly enrolled devices.`,
  modernMDMEnrollment: "Modern MDM enrollment",
  modernMDMDescription: `Download & install agents on endpoint devices to enroll them on Trio.`,
  clickToDownloadYourAgent: "Click the button below to download your agent",
  downloadAgent: "Download agent",
  close: "Close",
  agentlessDownloadDescription: `Download & install profiles on end-point devices to enroll them in
  Trio.`,
  agentlessDownloadYourProfile: "Click button below download your profile",
  yourCompanyPairingCode: `Your company's pairing code`,
  companyPairingCodeDescription: `This code allows you to enroll devices to your company.`,
  changeCode: "Change Code",
  enrollmentLink: "Enrollment link",
  enrollmentLinkSubtitle: `Open the enrollment link on the device you want to enroll to download Trio's agent directly on that device.`,
  shareEnrollmentEmailWithEmployees: `Share enrollment email with users`,
  pairingCode: "Pairing code",
  selectEmployees: "Select users",
  addOffice: "Add office",
  personalEmail: "Personal email",
  startDate: "Start date",
  send: "Send",
  nothingFound: "Nothing found",
  appleId: "Apple ID",
  enrolledDeviceSubtitle:
    "Enroll devices and add them to your Inventory or directly assign them to a autopilot or user.",
  deviceInventoryHeaderSubtitle: `The Devices section lets you add, manage, monitor, and keep all types of devices compliant through a streamlined, centralized workflow.`,
  accessoriesHeaderSubtitle: `Specify the details of your IT equipment and the user using them.`,
  networkInformation: "Network information",
  saveChanges: "Save changes",
  device_profile_assignment: "Device & Profile assignment",
  select_accessories: "Select accessories & choose their delivery method",
  peripheral_select_unlimited_number:
    "You can select an unlimited number of accessories for an user.",
  add_accessory: "Add Accessory",
  add_first_access: "Add First Accessory",
  delivery_method: "Delivery method",
  assigned_devices: "Assigned Devices",
  no_device_assign: "No device has been assigned.",
  no_accessory: "No accessory has been assigned.",
  select_action: "Clean this device’s data?",
  no_action: "No action",
  no_need: "No need",
  retrieve: "Retrieve",
  no_retrieve: "Not retrieve",
  clean_data: "Clean data",
  should_return: "Retrieve this item?",
  peripheral_retrieve: "Do you want back or retrieve device in company",
  archive_user_account: "Archived user accounts",
  remoteMaintenance: "Maintenance",
  stopRunScript: "Stop run script",
  scriptRan: "Script ran",
  remote_desktop: {
    title: "Remote desktop",
    sub_title:
      "Connect and remotely control the device to perform live maintenance tasks.",
    activate_remote_desktop: "Activate remote desktop",
    click_description: "Click on the button below to activate remote desktop.",
    connection_type: "Connection type: ",
    connect_to_desktop: "Connect to desktop",
    attended: "Attended",
    alert:
      "All responsibility for using the free version for business purposes is yours.",
  },
  liveTerminal: "Live Terminal",
  liveTerminalSubtitle:
    "Connect to a remote terminal session to run ad-hoc commands.",
  openTerminal: "Open terminal",
  connected: "Connected",
  busy: "Busy",
  closeSession: "Close session",
  submitPressEnter: "Submit - Press Enter",
  noSessionRanOnThisDevice: "No session ran on this device.",
  windows_defender: "Windows Defender",
  real_time_protection: "Real time Protection",
  bitlocker: "Bitlocker",
  public_profile_enable: "Public Profile enable",
  standard_profile_enable: "Standard Profile enable",
  domain_profile_enable: "Domain Profile enable",
  bitlocker_active: "Bitlocker Active",
  bitlocker_inactive: "Bitlocker Inactive",
  active: "Active",
  inactive: "Inactive",
  userPrivilegeLists: {
    GUEST: "Guest",
    STANDARD: "Standard",
    ADMINISTRATOR: "Admin",
    SHARINGONLY: "Sharing only",
  },
  enable_remote_desktop: "Enable remote desktop",
  enable_remote_desktop_question: "Enable remote desktop?",
  disable_remote_desktop: "Disable remote desktop",
  disable_remote_desktop_question: "Disable remote desktop؟",
  enable_remote_desktop_desc:
    "Enable remote desktop to use your computer from anywhere. Would you like to proceed?",
  disable_remote_desktop_desc: "Are you sure you want disable remote desktop?",
  enable_remote_desktop_command_sent_successfully:
    "Enable Remote Desktop command has been sent to device successfully.",
  enable_remote_desktop_command_done_successfully:
    "Device remote desktop has been enabled successfully.",
  enable_remote_desktop_command_done_fail:
    "There is a problem with enabling device remote-desktop",
  disable_remote_desktop_command_sent_successfully:
    "Disable Remote Desktop command has been sent to device successfully.",
  disable_remote_desktop_command_done_successfully:
    "Device remote desktop has been disabled successfully.",
  disable_remote_desktop_command_done_fail:
    "There is a problem with disabling device remote-desktop",
  device_need_online: "device need to be online",
  run_script: "Run script",
  run_ready_scripts_devices:
    "Run scripts to automate information collection and perform maintenance tasks.",
  search_script: "search in script",
  When_you_want_run_script: "When you want to run this script?",
  run_new_script: "Run new script",
  no_scripts_ran_device: "No scripts ran on this device.",
  script_details: "Script details",
  run_script_create_new_script: "Run script / Create new script",
  run_script_create_new_script_write_script:
    "Run script / Create new script / Write Script",
  right_now: "Right now",
  scheduled: "Scheduled",
  choose_period: "Choose period",
  daily: "Daily",
  weekly: "Weekly",
  select_here: "Select here",
  set_time: "Set time",
  select_day_week: "Select days of week:",
  export: "Export",
  result: "Result",
  copy_command: "Copy command",
  script_list: "Script list",
  create_script: "Create script",
  write_new_script_upload_one: "Write a new script or upload an existing one.",
  no_scripts_added: "No scripts added",
  script_view: "Script View",
  got_it: "Got it",
  your_script: "Your Script",
  upload_script_file_instead: "Upload the script file instead",
  create_script_description:
    "Create your own script and run it. This script will be saved in the My scripts section.",
  run_as: "Run as",
  drag_drop: "Drag & Drop or browse to choose a file",
  only_sh: "Only {{value}} format. (maximum 5 MB)",
  file_uploaded_successfully: "Your file uploaded successfully",
  write_script_scratch: "Write your script from scratch",
  write_script_here: "Write your script here",
  cancel_back: "Cancel & Back",
  confirm_save: "Confirm & Save",
  user_account_privilege: "User account privilege",
  select_access_level: "Select access level for “{{name}}” account:",
  change_user_password: "Change user account password",
  change_account_password: "Change account password",
  define_new_pass: "Define new strong password",
  delete_account: "Delete account",
  delete_account_desc:
    "Once an account is deleted, the user will lose all access to it.",
  suspend_account: "Suspend account?",
  suspend_account_desc:
    "By suspending an account, user no longer can login to that account.",
  active_account: "Active account",
  active_account_desc:
    "Unlocking this user account grants them full access to their account and all its features and services.",
  remoteDesktop: "Remote Desktop",
  runScript: "Run Script",
  command: "Command",
  sessionDate: "Session date",
  connectionHistory: "Connection History",
  commandPrompt: "Command Prompt",
  commandDetails: "Command details",
  terminalSessionHistory: "Terminal Session History",
  cmdSessionHistory: "CMD Session History",
  powershellSessionHistory: "Powershell Session History",
  showMore: "Show more",
  powershell: "Powershell",
  taskManager: "Task Manager",
  process_killed_successfully: "Process killed successfully.",
  activity_monitor: "Activity Monitor",
  manage_processes_endpoint_devices:
    "Monitor and control active processes on the device.",
  refresh_data: "Refresh data",
  quit_process: "Quit process?",
  quitting_process_kill_endpoint_device:
    "Quitting process will kill it on end-point device.",
  forceQuit: "Force quit",
  quit: "Quit",
  process_details: "Process details",
  qot_it: "Got it",
  process_name: "Process name",
  PID: "PID",
  CPU_usage: "CPU usage (%)",
  memory_usage: "Memory usage (%)",
  GPU_usage: "GPU usage (%)",
  parent_process: "Parent process",
  parent_group: "Parent autopilot",
  powershellSubtitle: "PowerShell environment on device",
  cmdSubtitle: "Command prompt environment on device",
  cmd: "Command prompt",
  cmdErrorOffline: "You need online device for CMD",
  deviceIsOffline: "The device is offline",
  powershellErrorOffline: "You need online device for powershell",
  liveTerminalErrorOffline: "You need online device for live terminal",
  service_manager: "Service Manager",
  service_manager_desc: "Monitor and control services on the device.",
  operatingSystem: "Operating system",
  openCMD: "Open CMD",
  openPowerShell: "Open Powershell",
  open_live_terminal: "Open Live terminal",
  open_run_script: "Open Run script",
  open_activity_monitor: "Open Activity monitor",
  open_service_manager: "Open Service manager",
  commandPromptCMD: "Command Prompt (CMD)",
  trio_user: "Trio User",
  username: "Username",
  sync: "Sync",
  kioskmodestatus: "Kiosk mode status",
  send_notification: "Send notification",

  send_blank_push: "Send blank push",
  not_assigned: "not assigned",
  runReadyToUseScripts: "Monitor and control active processes on the device.",
  assignToEmployee: "Assign to user",
  assignToDepartment: "Assign to autopilot",
  online_status: "Online status",
  unkown: "Unkown",
  hardwareOverview: "Hardware overview",

  select_your_operation_system: "Select your Operation system",
  download_os_agent: "Download {{os}} agent",
  download_agent_directly: "Click the button below to download your agent",
  download_profile_ios: "Download iPhone & iPad profile",
  download_profile_ios_desc:
    "To download iPhone and iPad device profiles, make a selection.",
  employee_profile: "User profile",
  department_profile: "Autopilot profile",
  get_profile: "Get profile",
  get_profile_via_paircode: "Get profile via pair code",
  download_company_profile: "Download Company profile",
  scan_QR_code_employee: "Scan the QR code below to download the user profile",
  scan_QR_code_department:
    "Scan the QR code below to download the autopilot profile",
  change_employee: "Change user",
  change_department: "Change autopilot",
  download_profile_directly: "Download the profile directly",
  download_android_agent_desc:
    "Choose how you want to download the profile for your Android device",
  scan_QR_code_android: "Scan the QR code below to download Android agent",
  download_directly: "Click the button below to download the profile",
  enter_pair_code: "Enter your pair code",
  download_profile: "Download profile",
  using_device: "We detected you are using {{device}}",
  easily_enroll_device_android:
    "Easily enroll your device by scanning the QR code, downloading the APK file, or getting the application on Google Play Store.",
  download_apk_file: "Download APK file",

  //<== update ==>\\

  storage: "Storage",
  memory: "Memory",
  CPU: "CPU",
  plugIn: "Plug-in",
  operation_system: "Operating System",
  enrollmentDetail: "Enrollment detail",
  managed: "Managed",
  alerts: "Alerts",
  noAlerts: "No alert",
  pastSevenDays: "in past 7 days",
  deviceAssignment: "Device assignment",
  cancelScriptMessage: "How do you want to cancel this script?",
  cancelScript: "Cancel script",
  onlyThisTime: "Only this time",
  cancelForever: "Cancel this scheduling forever",
  confirm: "Confirm",
  stopScriptConfrirm: "Do you want to stop this script from running?",
  application: "Application",
  applications: "Applications",
  internalStorage: "Internal Storage",
  externalStorage: "External Storage",
  liveMonitoring: "Live Monitoring",
  listUpdated: "List updated",
  restart: "Restart",
  start: "Start",
  stop: "Stop",
  appInformation: "App information",
  installedApplication: "Installed applications",
  source: "Source",
  installedTime: "Installed time",
  lastTimeUpdate: "Last update time",
  dataDirectoryUpdate: "Data directory address",
  grantedPermissions: "Granted permissions",
  requestedPermissons: "Requested permissions",
  startuptype: "Startup type",
  availableValue: "Available: {{value}} GB",
  LoadValue: "Load: {{value}}%",
  charging: "Charging ...",
  live_hardware_monitoring: "Live hardware monitoring",
  valueAvailable: "of {{value}} GB available",
  temperature: "Temperature",
  devicetemperature:
    "The device temperature is within the optimal range for work.",
  trash: "Trash",
  Clear_all: "Clear all",
  Usedkbof: "Used {{trashDataAvailable}} kb of {{trashDataUsed}} GB",
  Storage_usage: "Storage usage",
  last_3_days: "Last 3 days",
  last_week: "Last week",
  last_month: "Last month",
  storage_usage_average: "Storage usage average",
  wired: "Wired",
  compressed: "Compressed",
  top_consumers: "Top consumers",
  memoryUsage: "Memory usage",
  memory_usage_average: "Memory usage average",
  usage: "Usage",
  battery: "Battery",
  running_battery: "It’s running by battery",
  charge_cycle: "Charge Cycle",
  health: "Health",
  battery_good_condition:
    "This battery is in good condition, but lost some capacity",
  device_temperature:
    "The device temperature is within the optimal range for work.",
  unEnrollCommandSentSuccessfullyOffline:
    "The device is offline. Trio will automatically unenroll the device once it is connected to the internet",
  unEnrollCommandSentSuccessfullyOnline:
    "Unenrollment command sent to the device.",
  add_accessory_desc:
    "Add accessories to your inventory to assign them to users in the next step.",
  process_killed_fail: "Unable to terminate process",
  averageUsage: "Average usage",
  Topconsumerprocessname: "Top consumer process name",
  hostname: "Host name",
  details: "Details",
  apiLevel: "API Level",
  uuid: "UUID",
  globalProxy: "Global Proxy",
  address: "Address",
  dnsServer: "DNS server",
  privateKey: "Private key",
  online: "Online",
  offline: "Offline",
  bypass: "Bypass",
  host: "Host",
  screenSize: "Screen size",
  onlineStatus: "Online status",

  enroll_ios_ipadOs: "Enroll iPhone/iPad device",
  a_android_device: "An Android device",
  an_iphone: "an IPhone",
  a_macbook: "a MackBook",
  a_windows: "a Windows",
  macos: "Mac",

  total: "Total",
  used: "Used",
  plugandplay: "Power",
  nobatteryavailableonthisdevices: "Connected",
  uselivehardwaremonitoring:
    "Use live hardware monitoring to see current Storage, Memory, CPU consumption and trends.",
  cpu_usage: "CPU Usage",
  edit: "Edit",
  inputNewHostName: "Input new host name",
  notCharging: "Not Charging",
  deviceOwner: "(*device owner)",
  showLockPinCode: "Lock with PIN code",
  resetLockScreenMessage: "Set lock screen message",
  resetDevicePassword: "Reset device password",
  lock_command_send_successfully:
    "Lock command has been sent to device successfully.",
  sync_command_send_successfully:
    "Sync command has been sent to device successfully.",
  reboot_command_send_successfully:
    "Reboot command has been sent to device successfully.",
  reset_command_send_successfully:
    "The reset password command has been successfully sent to the device.",
  disableLostMode_command_send_successfully:
    "Disable Lost Mode command has been sent to device successfully.",
  delete_command_send_successfull:
    "Delete command has been sent to device successfully.",
  launch_command_send_successfully:
    "Launch command has been sent to device successfully.",
  close_command_send_successfully:
    "Close command has been sent to device successfully.",
  uninstall_command_send_successfully:
    "Uninstall command has been sent to device successfully.",
  install_command_send_successfully:
    "Install command has been sent to device successfully.",
  clearAppData_command_send_successfully:
    "Clear app data command has been sent to device successfully.",
  lockDialogText: `Are you sure you want to lock this device? Device cannot be unlocked unless the correct passcode is entered.`,
  deleteDialogText: `Removes the work profile and all policies from a company-owned Android device, relinquishing the device for personal use. Apps and data associated with the personal profile(s) are preserved. The device will be deleted from the server after it acknowledges the command.`,
  lockConfirm: `Yes, Lock`,
  removeConfirm: `Yes, Remove`,
  removeProfile: `Remove profile`,
  updates: "Updates",
  on: "On",
  off: "Off",
  location: "Location",
  lockDialogTitle: `Do you want lock this device?`,
  deleteDialogTitle: `Do you want Remove the work profile`,
  cpuArchiecture: "CPU Archiecture",
  securityAutomation: "Security automation",
  seeSecurity: "See security",
  softwareUpdateConfirm:
    "Are you sure you want to update the operating system?",
  profiles: "Profiles",
  profileDetails: "Profile details",
  seeDetails: "See details",
  securities: "Securities",
  configuration: "Configuration",
  exception: "Exception",
  emptyStateDescription:
    "This device will received assigned autopilot's profile",
  emptyStateTitle: "Device doesn’t have any profiles yet",
  enrollmentDate: "Enrollment Date",
  licence: "Licence",
  store: "Store",
  applicationNotdata: "You don’t have any application yet",
  enableLostMode: "Enable lost mode",
  disableLostMode: "Disable lost mode",
  lostMode: "Lost mode",
  enrollmentType: "Enrollment type",
  profile: "Profile",
  ram: "RAM",
  hardware: "Hardware",
  devicePolicy: "Device Policy",
  buildNumber: "Build number",
  kernelVersion: "Kernel version",
  bootLoaderVersion: "Boot loader version",
  androidBuildTime: "Build time",
  securityPatchLevel: "Security Patch Level",
  primaryLanguageCode: "Primary language code",
  deviceBuildSignature: "Device build signature",
  enrollment: "Enrollment",
  enrollmentTokenUsed: "Enrollment token used",
  enrollmentTokenID: "Enrollment token ID",
  wifiMacAddress: "WIFI MAC Address",
  phoneNumber: "Phone number",
  carrierName: "Carrier name",
  iccId: "iccId",
  telephonyInfo: "Telephony Info",
  networkMonitor: "Network Monitor",
  networkMonitoring: "Network monitoring",
  networkMonitoringDescription: "Keep a real-time watch on all device ports.",
  assignToBoth: "Assign to both",
  archive: "Archive",
  departments: "Autopilot",
  selectFromDepartments: "Select from autopilot",
  selectFromEmployee: "Select from user",
  selectFromActiveEmployee: "Select from active users",
  changeEmployeeAssignment: "Change assignment user",
  changeAssignDepartment: "Change autopilot",
  employee: "User",
  assignToBothToDepartment: "Autopilot",
  unassignEmployeeDevice: "Unassignment user",
  unassignDepartmentDevice: "Unassignment autopilot",
  areYouSureUnassign: "Are you sure, you want to unassign?",
  unassignmenDevice: "Device unassignment",
  delete_device: "Delete device",
  downloadProfile: "Download profile",
  playLostModeSound: "Play lost mode Sound",
  deviceIsMakingBuzzSound: "Device is making buzz sound.",
  enableBuzzSound: "Do you want to enable the buzz sound?",
  enableSound: "Enable sound",
  gotoDeviceLocation: "Go to device location.",
  enableLostMode_command_send_successfully:
    "Enable Lost Mode command has been sent to device successfully.",
  unassign_from_group: "Unassign from autopilot",
  editTagsAddAndRemove: "Edit tags (add/remove)",
};
